/** @format */

import React from "react";
import "./Footer.css";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <footer>
      <div className="copyright-text">© 2016 - {year} YouROK Corp.</div>

      <a href="/privacy">Privacy Policy</a>
      <a href="/termsofuse">Terms of Use</a>
      <a href="/faqs">FAQs</a>
      <a href="/careers">Careers</a>
      <a href="/press">Press</a>
      <a href="./Contact" className="contact-link">
        Contact
      </a>
    </footer>
  );
}

export default Footer;
